<template>
  <div class="more" id="partner">
    <div class="container">
      <div class="more__wrapper">
        <svg class="more__image1" width="73" height="73" viewBox="0 0 73 73" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="36.5" cy="36.5" r="36.5" fill="#4367E2"/>
        </svg>
        <svg class="more__image2" width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="15" cy="15" r="15" fill="#F4B767"/>
        </svg>
        <div class="more__left">
          <p class="more__title"><span>More than marketing</span> — we create meaningful experiences that elevate your brand and shape lasting relationships.</p>
          <div class="more__text">At ALCOR INNOVATIVE LTD S.R.L., we don’t just offer marketing services — we become your strategic partner in growth. Join forces with a team that’s committed to your success, understands your vision, and works side by side with you every step of the way. Let’s build something extraordinary together.</div>
        </div>
        <img class="more__image" src="@images/moreImage.png" alt="image">
      </div>
    </div>
  </div>
</template>

<script setup>

</script>

<style lang="scss" scoped>
.more {
  padding-top: 125px;

  &__wrapper {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  &__image1 {
    position: absolute;
    top: 0;
    left: 0;
  }
  &__image2 {
    position: absolute;
    bottom: 50px;
    left: 550px;
  }

  &__left {
    display: flex;
    flex-direction: column;
    gap: 17px;
  }

  &__title {
    color: #2F327D;
    font-size: 28px;
    font-weight: 500;
    line-height: 160%;

    & span {
      color: #F48C06;
    }
  }
  
  &__text {
    color: #696984;
    font-size: 18px;
    font-weight: 400;
    line-height: 180%;
    letter-spacing: 0.36px;
  }
}

@media (max-width: 1300px) {
  .more {
    &__image1 {
      display: none;
    }

    &__title {
      text-align: center;
      font-size: 22px;
    }

    &__text {
      text-align: center;
      line-height: 120%;
    }

    &__wrapper {
      flex-direction: column;
      gap: 50px;
    }
  }
}

@media (max-width: 750px) {
  .more {
    &__image {
      width: 100%;
    }
  }
}
</style>